import React, { useEffect } from 'react';
import feather from 'feather-icons';
import { NavLink, useLocation } from "react-router-dom";

function Sidebar() {

    const location = useLocation();
    useEffect(() => {
        feather.replace();
    }, []);

    const isOpen = (...prefixes) =>
        prefixes.some(p => location.pathname === p || location.pathname.startsWith(p + '/'));

    return (
        <nav className="navbar navbar-vertical navbar-expand-lg">
            <style>{`
            svg.feather  {
                padding: 2px;
            }`}
            </style>
            <div className="collapse navbar-collapse" id="navbarVerticalCollapse">
                {/* scrollbar removed */}
                <div className="navbar-vertical-content">
                    <ul className="navbar-nav flex-column" id="navbarVerticalNav">
                        <li className="nav-item">
                            {/* parent pages */}
                            <div className="nav-item-wrapper">
                                <button
                                    className="nav-link dropdown-indicator label-1"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#nv-home"
                                    aria-expanded={isOpen('/dashboard')}
                                    aria-controls="nv-home"
                                >
                                    <div className="d-flex align-items-center">
                                        <div className="dropdown-indicator-icon-wrapper">
                                            <span className="fas fa-caret-right dropdown-indicator-icon"></span>
                                        </div>
                                        <span className="nav-link-icon">
                                            <span data-feather="pie-chart"></span>
                                        </span>
                                        <span className="nav-link-text">ホーム</span>
                                    </div>
                                </button>

                                <div className="parent-wrapper label-1">
                                    <ul
                                        className={`nav collapse parent ${isOpen('/dashboard') ? 'show' : ''}`}
                                        data-bs-parent="#navbarVerticalCollapse"
                                        id="nv-home"
                                    >
                                        <li className="collapsed-nav-item-title d-none">Home</li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/dashboard"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">ダッシュボード</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>

                        <li className="nav-item">
                            <hr className="navbar-vertical-line" />

                            <div className="nav-item-wrapper">
                                {/* スポット管理 */}
                                <button
                                    className="nav-link dropdown-indicator label-1"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#nv-SPOT"
                                    aria-expanded={isOpen('/spot')}
                                    aria-controls="nv-SPOT"
                                >
                                    <div className="d-flex align-items-center">
                                        <div className="dropdown-indicator-icon-wrapper">
                                            <span className="fas fa-caret-right dropdown-indicator-icon"></span>
                                        </div>
                                        <span className="nav-link-icon">
                                            <span data-feather="map-pin"></span>
                                        </span>
                                        <span className="nav-link-text">スポット管理</span>
                                    </div>
                                </button>
                                <div className="parent-wrapper label-1">
                                    <ul
                                        className={`nav collapse parent ${isOpen('/spot') ? 'show' : ''}`}
                                        data-bs-parent="#navbarVerticalCollapse"
                                        id="nv-SPOT"
                                    >
                                        <li className="collapsed-nav-item-title d-none">スポット管理</li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/spot"
                                                end
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">スポット一覧</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/spot/new"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">スポット登録</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>

                                {/* 乗車券管理 */}
                                <button
                                    className="nav-link dropdown-indicator label-1"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#nv-TICKET"
                                    aria-expanded={isOpen('/ticket')}
                                    aria-controls="nv-TICKET"
                                >
                                    <div className="d-flex align-items-center">
                                        <div className="dropdown-indicator-icon-wrapper">
                                            <span className="fas fa-caret-right dropdown-indicator-icon"></span>
                                        </div>
                                        <span className="nav-link-icon">
                                            <span data-feather="credit-card"></span>
                                        </span>
                                        <span className="nav-link-text">乗車券管理</span>
                                    </div>
                                </button>
                                <div className="parent-wrapper label-1">
                                    <ul
                                        className={`nav collapse parent ${isOpen('/ticket') ? 'show' : ''}`}
                                        data-bs-parent="#navbarVerticalCollapse"
                                        id="nv-TICKET"
                                    >
                                        <li className="collapsed-nav-item-title d-none">乗車券管理</li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/ticket"
                                                end
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">乗車券一覧</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/ticket/new"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">乗車券登録</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>

                                {/* デジチケ管理 */}
                                {/* <button
                                    className="nav-link dropdown-indicator label-1"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#nv-dTICKET"
                                    aria-expanded={isOpen('/voucher')}
                                    aria-controls="nv-dTICKET"
                                >
                                    <div className="d-flex align-items-center">
                                        <div className="dropdown-indicator-icon-wrapper">
                                            <span className="fas fa-caret-right dropdown-indicator-icon"></span>
                                        </div>
                                        <span className="nav-link-icon">
                                            <span data-feather="credit-card"></span>
                                        </span>
                                        <span className="nav-link-text">デジチケ管理</span>
                                    </div>
                                </button>
                                <div className="parent-wrapper label-1">
                                    <ul
                                        className={`nav collapse parent ${isOpen('/voucher') || isOpen('/package') ? 'show' : ''}`}
                                        data-bs-parent="#navbarVerticalCollapse"
                                        id="nv-dTICKET"
                                    >
                                        <li className="collapsed-nav-item-title d-none">デジチケ管理</li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/voucher"
                                                end
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">バウチャー一覧</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/voucher/new"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">バウチャー登録</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/package"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">パッケージ一覧</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/package/new"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">パッケージ登録</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div> */}

                                {/* クーポン管理 */}
                                <button
                                    className="nav-link dropdown-indicator label-1"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#nv-COUPON"
                                    aria-expanded={isOpen('/coupon')}
                                    aria-controls="nv-COUPON"
                                >
                                    <div className="d-flex align-items-center">
                                        <div className="dropdown-indicator-icon-wrapper">
                                            <span className="fas fa-caret-right dropdown-indicator-icon"></span>
                                        </div>
                                        <span className="nav-link-icon">
                                            <span data-feather="tag"></span>
                                        </span>
                                        <span className="nav-link-text">クーポン管理</span>
                                    </div>
                                </button>
                                <div className="parent-wrapper label-1">
                                    <ul
                                        className={`nav collapse parent ${isOpen('/coupon') ? 'show' : ''}`}
                                        data-bs-parent="#navbarVerticalCollapse"
                                        id="nv-COUPON"
                                    >
                                        <li className="collapsed-nav-item-title d-none">クーポン管理</li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/coupon"
                                                end
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">クーポン一覧</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/coupon/new"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">クーポン登録</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>

                                {/* イベント管理 */}
                                <button
                                    className="nav-link dropdown-indicator label-1"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#nv-EVENT"
                                    aria-expanded={isOpen('/event')}
                                    aria-controls="nv-EVENT"
                                >
                                    <div className="d-flex align-items-center">
                                        <div className="dropdown-indicator-icon-wrapper">
                                            <span className="fas fa-caret-right dropdown-indicator-icon"></span>
                                        </div>
                                        <span className="nav-link-icon">
                                            <span data-feather="calendar"></span>
                                        </span>
                                        <span className="nav-link-text">キャンペーン管理</span>
                                    </div>
                                </button>
                                <div className="parent-wrapper label-1">
                                    <ul
                                        className={`nav collapse parent ${isOpen('/event') ? 'show' : ''}`}
                                        data-bs-parent="#navbarVerticalCollapse"
                                        id="nv-EVENT"
                                    >
                                        <li className="collapsed-nav-item-title d-none">キャンペーン管理</li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/event"
                                                end
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">キャンペーン一覧</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/event/new"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">キャンペーン登録</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>

                                {/* 実績管理 */}
                                <button
                                    className="nav-link dropdown-indicator label-1"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#nv-SUMMARY"
                                    aria-expanded={isOpen('/summary')}
                                    aria-controls="nv-SUMMARY"
                                >
                                    <div className="d-flex align-items-center">
                                        <div className="dropdown-indicator-icon-wrapper">
                                            <span className="fas fa-caret-right dropdown-indicator-icon"></span>
                                        </div>
                                        <span className="nav-link-icon">
                                            <span data-feather="bar-chart"></span>
                                        </span>
                                        <span className="nav-link-text">実績管理</span>
                                    </div>
                                </button>
                                <div className="parent-wrapper label-1">
                                    <ul
                                        className={`nav collapse parent ${isOpen('/summary') ? 'show' : ''}`}
                                        data-bs-parent="#navbarVerticalCollapse"
                                        id="nv-SUMMARY"
                                    >
                                        <li className="collapsed-nav-item-title d-none">実績管理</li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/summary/sales"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">購入実績</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/summary/usage"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">利用実績</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                        {/* <li className="nav-item">
                                            <NavLink
                                                to="/summary/ticket"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">取得チケット</span>
                                                </div>
                                            </NavLink>
                                        </li> */}
                                        <li className="nav-item">
                                            <NavLink
                                                to="/summary/point"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">ポイント実績</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/summary/view"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">閲覧実績</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>

                                {/* 会員管理 */}
                                <button
                                    className="nav-link dropdown-indicator label-1"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#nv-MEMBER"
                                    aria-expanded={isOpen('/user')}
                                    aria-controls="nv-MEMBER"
                                >
                                    <div className="d-flex align-items-center">
                                        <div className="dropdown-indicator-icon-wrapper">
                                            <span className="fas fa-caret-right dropdown-indicator-icon"></span>
                                        </div>
                                        <span className="nav-link-icon">
                                            <span data-feather="user"></span>
                                        </span>
                                        <span className="nav-link-text">会員管理</span>
                                    </div>
                                </button>
                                <div className="parent-wrapper label-1">
                                    <ul
                                        className={`nav collapse parent ${isOpen('/user') ? 'show' : ''}`}
                                        data-bs-parent="#navbarVerticalCollapse"
                                        id="nv-MEMBER"
                                    >
                                        <li className="collapsed-nav-item-title d-none">会員管理</li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/user"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">会員一覧</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>
                                {/* スタンプラリー管理 */}
                                <button
                                    className="nav-link dropdown-indicator label-1"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#nv-STAMPRALLY"
                                    aria-expanded={isOpen('/stamprally')}
                                    aria-controls="nv-STAMPRALLY"
                                >
                                    <div className="d-flex align-items-center">
                                        <div className="dropdown-indicator-icon-wrapper">
                                            <span className="fas fa-caret-right dropdown-indicator-icon"></span>
                                        </div>
                                        <span className="nav-link-icon">
                                            <span data-feather="flag"></span>
                                        </span>
                                        <span className="nav-link-text">スタンプラリー管理</span>
                                    </div>
                                </button>
                                <div className="parent-wrapper label-1">
                                    <ul
                                        className={`nav collapse parent ${isOpen('/stamprally') ? 'show' : ''}`}
                                        data-bs-parent="#navbarVerticalCollapse"
                                        id="nv-STAMPRALLY"
                                    >
                                        <li className="collapsed-nav-item-title d-none">スタンプラリー管理</li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/stamprally"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">スタンプラリー一覧</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/stamprally/new"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">スタンプラリー登録</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>
                                {/* お知らせ管理 */}
                                <button
                                    className="nav-link dropdown-indicator label-1"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#nv-NOTICE"
                                    aria-expanded={isOpen('/information')}
                                    aria-controls="nv-NOTICE"
                                >
                                    <div className="d-flex align-items-center">
                                        <div className="dropdown-indicator-icon-wrapper">
                                            <span className="fas fa-caret-right dropdown-indicator-icon"></span>
                                        </div>
                                        <span className="nav-link-icon">
                                            <span data-feather="info"></span>
                                        </span>
                                        <span className="nav-link-text">お知らせ管理</span>
                                    </div>
                                </button>
                                <div className="parent-wrapper label-1">
                                    <ul
                                        className={`nav collapse parent ${isOpen('/information') ? 'show' : ''}`}
                                        data-bs-parent="#navbarVerticalCollapse"
                                        id="nv-NOTICE"
                                    >
                                        <li className="collapsed-nav-item-title d-none">お知らせ管理</li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/information"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">お知らせ一覧</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/information/new"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">お知らせ登録</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>

                                {/* プッシュ通知管理 */}
                                <button
                                    className="nav-link dropdown-indicator label-1"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#nv-NOTIFY"
                                    aria-expanded={isOpen('/notification')}
                                    aria-controls="nv-NOTIFY"
                                >
                                    <div className="d-flex align-items-center">
                                        <div className="dropdown-indicator-icon-wrapper">
                                            <span className="fas fa-caret-right dropdown-indicator-icon"></span>
                                        </div>
                                        <span className="nav-link-icon">
                                            <span data-feather="bell"></span>
                                        </span>
                                        <span className="nav-link-text">プッシュ通知管理</span>
                                    </div>
                                </button>
                                <div className="parent-wrapper label-1">
                                    <ul
                                        className={`nav collapse parent ${isOpen('/notification') ? 'show' : ''}`}
                                        data-bs-parent="#navbarVerticalCollapse"
                                        id="nv-NOTIFY"
                                    >
                                        <li className="collapsed-nav-item-title d-none">プッシュ通知管理</li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/notification"
                                                end
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">プッシュ通知一覧</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/notification/new"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">プッシュ通知登録</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>

                                {/* サービス管理 */}
                                <button
                                    className="nav-link dropdown-indicator label-1"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#nv-SETTING"
                                    aria-expanded={isOpen('/setting')}
                                    aria-controls="nv-SETTING"
                                >
                                    <div className="d-flex align-items-center">
                                        <div className="dropdown-indicator-icon-wrapper">
                                            <span className="fas fa-caret-right dropdown-indicator-icon"></span>
                                        </div>
                                        <span className="nav-link-icon">
                                            <span data-feather="settings"></span>
                                        </span>
                                        <span className="nav-link-text">サービス管理</span>
                                    </div>
                                </button>
                                <div className="parent-wrapper label-1">
                                    <ul
                                        className={`nav collapse parent ${isOpen('/setting') ? 'show' : ''}`}
                                        data-bs-parent="#navbarVerticalCollapse"
                                        id="nv-SETTING"
                                    >
                                        <li className="collapsed-nav-item-title d-none">サービス管理</li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/setting/transit"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">交通系メニュー</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/setting/guide"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">ガイド・規約管理</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                to="/setting/point"
                                                className={({ isActive }) =>
                                                    "nav-link" + (isActive ? " active" : "")
                                                }
                                            >
                                                <div className="d-flex align-items-center">
                                                    <span className="nav-link-text">ポイント設定</span>
                                                </div>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="navbar-vertical-footer">
                <button
                    type="button"
                    className="btn navbar-vertical-toggle border-0 fw-semibold w-100 white-space-nowrap d-flex align-items-center"
                // TODO: wire to your collapse/expand sidebar state
                >
                    <span className="uil uil-left-arrow-to-left fs-8"></span>
                    <span className="uil uil-arrow-from-right fs-8"></span>
                    <span className="navbar-vertical-footer-text ms-2">Collapsed View</span>
                </button>
            </div>
        </nav>
    );
}

export default Sidebar;
